/**
 * Reponses aux questions
 */
export type QuestionReponse = {
    questionPrecedenteCode?: string;
    reponsePrecedente?: string;
    questionCode: string;
    questionLibelle?: string;
    reponseCode: string;
    reponseLibelle?: string;
    isQuestionActuelle?: boolean; //--- si c'est la question actuellement affichée
};

/**
 * La question finale n'a pas de code, le front lui en donne un "par défaut" pour la reconnaitre
 */
export const CODE_FINAL_QUESTION: string = "final";
